import React, { Fragment } from 'react';
import type { ColorParams } from '@bynder-studio/render-core';
import { colorParams2Color } from 'packages/common/editor/editorHelper';
import { useElementStyleModal } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextStyles/modals/useElementStyleModal';
import { BrandColor, BrandColorPalette } from 'packages/store/brandColors/types';
import { BrandColorOnElement } from 'packages/pages/editor/RightSideMenu/FormComponents/EditorColor';
import { FullWidthFlex } from './Component.styled';
import { SidebarSection } from '../../../../FormComponents/EditorColor/EditorColor.styled';
import ColorSearch from '../../../../FormComponents/EditorColor/components/ColorSearch';
import ColorPicker from '../../../../FormComponents/ColorPicker';
import ColorDropdown from '../../../../FormComponents/EditorColor/components/ColorsDropdown';
import ColorDetach from '../../../../FormComponents/EditorColor/components/ColorDetachDropdown';

type Props = {
    creativeModel: any;
    selectedElement: any;
    disabled: boolean;
    colorType: 'color' | 'strokeColor';
    testIdPrefix: string;
    label: string;
    hasBrandColors: boolean;
    isMixed: boolean;
    isAlphaMixed: boolean;
    onChange: (val: unknown) => void;
    colors: ColorParams[];
    palettes: BrandColorPalette[];
    brandColors: BrandColorOnElement[] | [];
    customColors: ColorParams[] | [];
    onAppliedClick: (color: BrandColor | ColorParams) => void;
    setBrandColor: (color: BrandColor) => void;
    onColorDetach: () => void;
    elementColors: ColorParams[] | [];
};
export const ColorManipulatorView = ({
    creativeModel,
    selectedElement,
    disabled,
    colorType,
    testIdPrefix,
    label,
    hasBrandColors,
    isMixed,
    isAlphaMixed,
    onChange,
    colors,
    palettes,
    brandColors,
    customColors,
    onAppliedClick,
    setBrandColor,
    onColorDetach,
    elementColors,
}: Props) => {
    const { openElementColorStylesModal, renderElementStyleModal } = useElementStyleModal({
        creativeModel,
        selectedElement,
    });

    const Wrapper = !hasBrandColors ? SidebarSection : Fragment;

    return (
        <FullWidthFlex>
            <Wrapper>
                {!hasBrandColors && (
                    <ColorPicker
                        id={selectedElement?.id}
                        testId={testIdPrefix}
                        label={label}
                        value={colorParams2Color(colors[0])}
                        isMixed={isMixed}
                        isAlphaMixed={isAlphaMixed}
                        handleOnChange={onChange}
                        disabled={disabled}
                    />
                )}
                <ColorDropdown
                    testId={testIdPrefix}
                    colors={colors}
                    palettes={palettes}
                    selectedBrandColors={brandColors}
                    disabled={disabled}
                >
                    <ColorSearch
                        elementColors={elementColors}
                        onAppliedClick={onAppliedClick}
                        selectedBrandColors={brandColors}
                        selectedCustomColors={customColors}
                        setBrandColor={setBrandColor}
                        palettes={palettes}
                        openElementStylesModal={openElementColorStylesModal}
                        testId={testIdPrefix}
                        colorType={colorType}
                    />
                </ColorDropdown>
                {hasBrandColors && (
                    <ColorDetach
                        hasMultipleColors={isMixed}
                        testId={testIdPrefix}
                        onColorDetach={onColorDetach}
                        disabled={disabled}
                    />
                )}
            </Wrapper>
            {renderElementStyleModal()}
        </FullWidthFlex>
    );
};

export default ColorManipulatorView;
